<template>
  <div
    class="send-to-multiple-people-modal__cover"
    @click.self="onClickModalCover"
  >
    <div class="send-to-multiple-people-modal__content">
      <div class="send-to-multiple-people-modal__header">
        <CloseCircleOutline
          class="send-to-multiple-people-modal__close-icon"
          @click="onClickCloseButton"
        />
        <h3>複数の相手にギフトを贈るには</h3>
      </div>
      <div class="send-to-multiple-people-modal__body">
        <div class="send-to-multiple-people-modal__examples">
          <div class="send-to-multiple-people-modal__example">
            <p class="send-to-multiple-people-modal__example-title">
              <span>ギフトの枚数を複数に設定しても</span>
              <span>一度の決済で作られるギフトカードは1枚です</span>
            </p>
            <img
              :src="SendToOnePersonImage"
              class="send-to-multiple-people-modal__image"
            />
          </div>
          <div class="send-to-multiple-people-modal__example">
            <p class="send-to-multiple-people-modal__example-title">
              <span>複数のギフトカードを贈りたい時は、</span>
              <span>人数分の決済が必要となります</span>
            </p>
            <img
              :src="SendToMultiplePeopleImage"
              class="send-to-multiple-people-modal__image"
            />
          </div>
        </div>
        <p class="send-to-multiple-people-modal__main-text">
          <!-- eslint-disable-next-line prettier/prettier 改行がない場合に空白が入らないよう1行にまとめる -->
          11名以上にギフトをまとめて購入したい場合は、<a href="https://giftee.com/announcements/69" target="_blank">まとめてオーダー</a>のご利用をご検討ください。
        </p>
      </div>
    </div>
  </div>
</template>

<script setup>
import CloseCircleOutline from '../../../atoms/svg_icons/CloseCircleOutline.vue'
import SendToOnePersonImage from '../../../../../../images/send-to-one-person.png'
import SendToMultiplePeopleImage from '../../../../../../images/send-to-multiple-people.png'

const emit = defineEmits(['clicked-modal-cover', 'clicked-close'])

const onClickModalCover = () => {
  emit('clicked-modal-cover')
}
const onClickCloseButton = () => {
  emit('clicked-close')
}
</script>
<style lang="scss" scoped>
.send-to-multiple-people-modal {
  &__cover {
    // TODO: z-index 全体を管理する際に適切なファイル、値にする
    // header が 100 なので 101 をセットする
    z-index: 101;
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 92%;
    padding: 0 4%;
    background-color: $dark_black_cover;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow-y: auto;
  }

  &__content {
    background: $white;
    border-radius: 8px;
    text-align: center;
    width: 100%;
    max-width: 343px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }

  &__header {
    @extend %body-bold;
    padding: 24px 24px 16px 24px;
    display: flex;
    align-items: center;
    gap: 8px;
    border-bottom: solid $gray-1 1px;
  }

  &__close-icon {
    cursor: pointer;
  }

  &__body {
    padding: 16px 24px 24px;
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  &__examples {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  &__example {
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 8px;
    gap: 8px;
    padding: 8px;
    background-color: $gray-3;
  }

  &__example-title {
    display: flex;
    flex-direction: column;
    border-radius: 4px;
    padding: 8px;
    background-color: $white;
    width: 100%;
    box-sizing: border-box;

    > span {
      font-weight: 700;
      font-size: 1.2rem;
      line-height: 160%;
      text-align: center;
    }
  }

  &__image {
    max-width: 251px;
    width: 100%;
    object-fit: contain;
  }

  &__main-text {
    @extend %caption;
    color: $black;
    text-align: left;
    line-height: 1.8rem;
  }

  &__image-area {
    width: 100%;
    border: solid $gray-2 1px;
    border-radius: 16px;
  }

  &__sub-text {
    @extend %minimal;
    color: $gray-1;
    text-align: left;
  }
}
</style>
